
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/[slug]",
      function () {
        return require("private-next-pages/programs/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/[slug]"])
      });
    }
  